import React from 'react';
import { Link } from 'react-router-dom';
import { APP_URL } from '../../../config/landing';

/* Footer link columns.
 *   to      = React Router route
 *   section = in-page section on the landing (routed as /v2#<section>)
 *   href    = external / app URL (rendered as a plain anchor)
 * Every link resolves to a real destination — no bare "#". */
const COLUMNS = [
  {
    title: 'Product',
    links: [
      { label: 'Terminal', href: APP_URL },
      { label: 'Features', section: 'features' },
      { label: 'Pricing', section: 'pricing' },
      { label: 'Changelog', to: '/changelog' },
      { label: 'Documentation', to: '/docs' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Academy', to: '/academy' },
      { label: 'Partner Program', to: '/affiliates' },
      { label: 'Community', section: 'community' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Risk Disclosure', to: '/risk-disclosure' },
      { label: 'Security', to: '/security' },
    ],
  },
];

const isExternal = (url) => /^https?:\/\//i.test(url);

function FooterLink({ link }) {
  if (link.to) return <Link to={link.to}>{link.label}</Link>;
  if (link.section) return <Link to={`/#${link.section}`}>{link.label}</Link>;
  // href → app/terminal URL: external origins open in a new tab, same-origin
  // paths stay in the SPA.
  if (isExternal(link.href)) {
    return <a href={link.href} target="_blank" rel="noopener noreferrer">{link.label}</a>;
  }
  return <Link to={link.href}>{link.label}</Link>;
}

export default function Footer({ brand }) {
  return (
    <footer>
      <div className="footer-grid">
        <div>
          <div className="footer-brand">
            <img className="logo-mark" src={brand.logo} alt={brand.name} />
            {brand.wordmark}
          </div>
          <p className="footer-desc">
            Market intelligence terminal for serious self-directed traders. Built in Bodø, Norway. Used worldwide.
          </p>
        </div>

        {COLUMNS.map((col) => (
          <div className="footer-col" key={col.title}>
            <h4>{col.title}</h4>
            <ul>
              {col.links.map((link) => (
                <li key={link.label}><FooterLink link={link} /></li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="footer-bottom">
        <div>© 2026 FlockTrade AS · Bodø, Norway · Org.nr 929 719 824</div>
        <div>Not financial advice. Trading involves risk.</div>
      </div>
    </footer>
  );
}
